import { isDevelopmentEnvironment } from "./environment.js";
export const isLocalhost = ["localhost", "127.0.0.1"].includes(location.hostname);
/** Set to false if you want to quickly test production. */
export const isDevelopment = isDevelopmentEnvironment;
/** Change the domain config for localhost. */
export const localHostConfigForDevelopment = "leo";
/** Auto load a left and a right foot scan. */
export const autoLoadModelsOnLoad = true && isDevelopment;
/** Auto loaded scan opacity. */
export const autoSetOpacityInDevelopment = 0.05;
/** Enabler service does not call the enabler web api. */
export const skipEnablerService = true && isDevelopment;
//# sourceMappingURL=configs.js.map